import { useCallback } from "react";

import { useFormContext } from "react-hook-form";

import { useRateContext } from "../Context/RateContext";

import { toFiniteNumber } from "@/common/helpers/toFiniteNumber";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const MINIMUM_GROUP_ATTENDEES = 2;

export const useEnableGroupTicket = () => {
  const { rateIndex } = useRateContext();
  const { setValue, getValues } = useFormContext<StepTicketsFormData>();

  return useCallback(
    (attendees?: number) => {
      setValue(`rates.${rateIndex}.isGroup`, true, { shouldDirty: true });
      const keptAttendees = toFiniteNumber(getValues(`rates.${rateIndex}.attendeesByTicket`));
      const nextAttendees =
        attendees ??
        (keptAttendees !== null && keptAttendees >= MINIMUM_GROUP_ATTENDEES ? keptAttendees : MINIMUM_GROUP_ATTENDEES);
      setValue(`rates.${rateIndex}.attendeesByTicket`, nextAttendees, { shouldDirty: true });
    },
    [rateIndex, setValue, getValues]
  );
};
